import React from 'react';
import { Redirect } from 'react-router-dom';
import leadsPathname from './firstLevelRoutes/Visitors/pathname'

const Home = () => <Redirect to={leadsPathname}/>;

export default Home;
